import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d2f3b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "join" }
const _hoisted_2 = { style: {"max-width":"320px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = ["href"]

import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import moment from 'moment-timezone'
import { IRoom } from '@/types/interfaces/room.interface'
import { catchJson } from '@/helpers/transform.helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'JoinFail',
  setup(__props) {

const route = useRoute()

const code = computed(() => route.query.code)
const link = computed(() => route.query.from as string)
const message = computed(() => route.query.message)
const timeAttend = computed(() => route.query.timeAttend as string)

const errorQuery = computed(() => catchJson((route.query.error as string) || '{}'))
const roomDetail = computed(() => errorQuery.value?.room as IRoom)

const isTimeOut = computed(() => {
  const attendAfterMin = roomDetail.value?.attendAfter > 0 ? roomDetail.value?.attendAfter : 0
  const endAttendTime = moment(roomDetail.value?.endTime).add(attendAfterMin, 'm')
  return route.query.code == 'ECONNABORTED' || moment().diff(endAttendTime) > 0
})
const attendTime = computed(() => {
  if (roomDetail.value?.startTime) {
    const attendBeforeMin =
      Number(roomDetail.value?.attendBefore) > 0 ? Number(roomDetail.value?.attendBefore) : 0
    const timeForAttend = moment(roomDetail.value?.startTime).subtract(attendBeforeMin, 'm')
    if (moment().diff(moment(timeAttend.value)) < 0) return timeForAttend.format('LLL')
  }
  return 0
})
onMounted(() => {
  /**
   * Don't For get to uncomment this code
   */
  // await axios.post('https://www.globish.co.th/webhook/space/event', {
  //   action: 'warning',
  //   message: message,
  //   code: code,
  //   link: link,
  // })
})

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_svg_icon, {
      class: "mb-2",
      icon: "sad-cloud",
      "inherit-fill": true,
      height: "64"
    }),
    _createElementVNode("div", _hoisted_2, [
      (code.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('join-fail-status')) + " " + _toDisplayString(code.value), 1))
        : _createCommentVNode("", true),
      (message.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(message.value), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('join-fail')), 1)),
      (attendTime.value || isTimeOut.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _withDirectives(_createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('join-fail-time-out')) + " ", 1),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(attendTime.value), 1)
            ], 512), [
              [_vShow, !isTimeOut.value]
            ]),
            _withDirectives(_createElementVNode("a", {
              class: "btn btn-primary mt-3",
              href: link.value
            }, [
              _createVNode(_component_svg_icon, {
                key: "reload",
                icon: "reload",
                "inherit-fill": true,
                width: "24",
                class: "mr-1"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('join-fail-reload-button')), 1)
            ], 8, _hoisted_9), [
              [_vShow, link.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})